import React, { useContext, useState } from "react"
import { Row, Col, Card, CardBody, Button } from "reactstrap"
import { post, put } from "helpers/api_helper"
import { useFormik } from "formik"
import * as Yup from "yup"
import { textField } from "components/Common/Form/InputFields"
import { CustomAlertContext } from "utils/context/CustomAlertContext"
import { yupMessages } from "helpers/validations/messages"
import { formats } from "helpers/validations/regex"
import { selectField } from "components/Common/Form/InputFields"

let language_options = [
  { name: "Arabic", value: "ar" },
  { name: "English", value: "en" },
]

let country_options = [
  { name: "South Africa", value: "+27" },
  { name: "UAE", value: "+971" },
]

const eyeSlash = <i className="mdi mdi-eye-off" />
const eye = <i className="mdi mdi-eye" />
const DeliverGuyForm = props => {
  const { disabled, deliverGuy_id, data = {} } = props
  const customAlert = useContext(CustomAlertContext)

  const handleSubmit = values => {
    if (values.password == "") {
      delete values.password
    }
    let callApi
    if (deliverGuy_id) {
      callApi = updateDeliverGuy(values)
    } else {
      values.otp = 1234
      callApi = addDeliverGuy(values)
    }

    callApi
      .then(res => {
        customAlert.notify(res.message)
        window.location.href = "/deliver-guys"
      })
      .catch(err => {
        customAlert.notify(err.response.data.message)
      })
  }

  const addDeliverGuy = data => post(`deliverGuys`, data)

  const updateDeliverGuy = data => put(`deliverGuys/${deliverGuy_id}`, data)

  const deliverGuySchema = Yup.object().shape({
    first_name: Yup.string()
      .trim(`First name ${yupMessages.trim}`)
      .required(`First name ${yupMessages.is_required}`)
      .matches(formats.string, yupMessages.first_name),
    last_name: Yup.string()
      .strict()
      .trim(`Last name ${yupMessages.trim}`)
      .required(`Last name ${yupMessages.is_required}`)
      .matches(formats.string, yupMessages.last_name),
    password: deliverGuy_id
      ? Yup.string()
          .strict()
          .trim()
          // .required(yupMessages.required)
          .matches(formats.password, yupMessages.password)
      : Yup.string()
          .trim()
          .required(`Password ${yupMessages.is_required}`)
          .matches(formats.password, yupMessages.password),
    email: Yup.string()
      .email(`Email ${yupMessages.string_email}`)
      .required(`Email ${yupMessages.is_required}`),
    city: Yup.string()
      .strict()
      .trim(`Email ${yupMessages.trim}`)
      .matches(formats.string, yupMessages.city_name),
    contact_number: Yup.string()
      .trim()
      .required(`Contact number ${yupMessages.is_required}`)
      .max(10, `Contact number ${yupMessages.string_max} 10 digits.`)
      .min(10, `Contact number ${yupMessages.string_min} 10 digits.`),
    language_code: Yup.string().required(
      `Language selection ${yupMessages.is_required}`
    ),
    country_code: Yup.string().required(
      `Country selection ${yupMessages.is_required}`
    ),
  })

  const formik = useFormik({
    initialValues: {
      first_name: data.first_name || "",
      last_name: data.last_name || "",
      email: data.email || "",
      contact_number: data.contact_number || "",
      city: data.city || "",
      language_code: data.language_code || "en",
      country_code: data.country_code || "",
    },
    validationSchema: deliverGuySchema,
    onSubmit: values => {
      handleSubmit(values)
    },
  })

  const [passwordShown, setPasswordShown] = useState(false)
  const togglePasswordVisiblity = () => {
    setPasswordShown(!passwordShown)
  }
  return (
    <Row>
      <Col className="col-12">
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="mb-3">
                <Col lg={6}>
                  {textField(
                    formik,
                    "first_name",
                    "First Name*",
                    "Enter your First Name"
                  )}
                </Col>
                <Col lg={6}>
                  {textField(
                    formik,
                    "last_name",
                    "Last Name*",
                    "Enter your Last Name"
                  )}
                </Col>
              </Row>
              <div className="mb-3">
                <Row>
                  <Col xl={6}>
                    {textField(
                      formik,
                      "email",
                      "E-Mail*",
                      "Enter Valid Email",
                      false,
                      "email"
                    )}
                  </Col>
                  <Col xl={6}>
                    <div className="mb-3 password-class">
                      {" "}
                      {textField(
                        formik,
                        "password",
                        "Password*",
                        "Enter your password",
                        false,
                        passwordShown ? "text" : "password"
                      )}
                      <i
                        className={`icon-password ${
                          formik.errors.password
                            ? formik.errors.password.length > 65
                              ? "iconPasswordLength"
                              : "mb-4"
                            : ""
                        }`}
                        onClick={togglePasswordVisiblity}
                      >
                        {passwordShown ? eyeSlash : eye}
                      </i>{" "}
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="mb-3 ">
                <Row>
                  <Col xl={6}>
                    {selectField(
                      formik,
                      "country_code",
                      "Country*",
                      country_options,
                      "Select country"
                    )}
                  </Col>
                  <Col xl={6}>
                    {textField(
                      formik,
                      "contact_number",
                      "Contact Number*",
                      "Enter your contact number",
                      false,
                      "number"
                    )}
                  </Col>
                </Row>
              </div>
              <div className="mb-3">
                <Row>
                  <Col xl={6}>
                    {selectField(
                      formik,
                      "language_code",
                      "Language",
                      language_options
                    )}
                  </Col>
                </Row>
              </div>
              <div className="mb-3" />
              <div className="d-flex flex-wrap gap-2">
                <Button type="submit" color="primary" className="">
                  Submit
                </Button>
              </div>
            </form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default DeliverGuyForm
